import graphql from 'babel-plugin-relay/macro';

const MarkJobRequestUploadFailedMutation = graphql`
  mutation MarkJobRequestUploadFailedMutation($input: MarkJobRequestUploadFailedInput!) {
    markJobRequestUploadFailed(input: $input) {
      jobRequest {
        id
        uploadStatus
        status
      }
    }
  }
`;

export default MarkJobRequestUploadFailedMutation;
